import { useCallback, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { usePaymentGeneralUpdateMutation } from 'api';
import { Form, FormProps, notification } from 'components';
import { IGeneralEditeModal } from 'feature/clientTabs/payments/general/edit/index';
import { ErrorMappingValueType } from 'typings';
import { PaymentGeneralFieldType } from 'typings/form/client/payment';

export const useGeneralEditModal = (props: IGeneralEditeModal) => {
  const { onModalStateChange, modalState, dataToEdit } = props;
  const [form] = Form.useForm();
  const { id } = useParams() as { id: string };
  const [notificationApi, contextHolder] = notification.useNotification();

  const [updatePaymentGeneral, { isLoading }] = usePaymentGeneralUpdateMutation();

  const openNotificationWithIcon = useCallback(
    (messageContent: ErrorMappingValueType) => {
      const { type, message } = messageContent;
      notificationApi[type]({
        message: message,
      });
    },
    [notificationApi]
  );

  const onCancel = useCallback(() => {
    form.resetFields();
    onModalStateChange();
  }, [form, onModalStateChange]);

  const onFinish: FormProps<PaymentGeneralFieldType>['onFinish'] = useCallback(
    (values: PaymentGeneralFieldType) => {
      const payload = values;
      payload.id = id;
      updatePaymentGeneral(payload)
        .then(({ data, error }: any) => {
          if (data?.success) {
            openNotificationWithIcon({
              type: 'success',
              message: 'General Details was successfully updated.',
            });
            onCancel();
          } else if (!error.data.success) {
            const { data = {} } = error.data;
            Object.keys(data).forEach((_key: string) => {
              openNotificationWithIcon({
                type: 'error',
                message: data[_key],
              });
            });
          } else if (error.data.error) {
            openNotificationWithIcon({
              type: 'error',
              message: 'Something went wrong!',
            });
          }
        })
        .catch((err) => {
          console.log(err, 'error');
        });
    },
    [id, updatePaymentGeneral, openNotificationWithIcon, onCancel]
  );

  useEffect(() => {
    if (modalState) {
      form.setFieldsValue(dataToEdit);
    }
  }, [modalState, dataToEdit, form]);

  return {
    onFinish,
    onCancel,
    contextHolder,
    form,
    isLoading,
  };
};
